import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearSettingDetails } from "./settingSlice";
import {
  createSetting,
  getAllSetting,
  getSettingByID,
  updateSetting,
} from "./services/setting.services";

import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import { closed } from "../../components/drawer/drawerSlice";
import IconButton from "../../components/common/IconButton";

const CreateSetting: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const SettingDetail = useAppSelector((state) => state.setting.SettingDetail);
  const SettingID = useAppSelector((state) => state.drawer.data);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [SettingDetail]);

  const formloading = useAppSelector((state) => state.setting.formloading);

  useEffect(() => {
    return () => {
      dispatch(clearSettingDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (SettingID) {
      dispatch(getSettingByID(SettingID));
    }
  }, [SettingID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!SettingID) {
        const insertPayload = {
          SettingKey: values?.SettingKey ? values?.SettingKey : "",
          SettingType: values?.SettingType ? values?.SettingType : "",
          SettingValue: values?.SettingValue ? values?.SettingValue : "",

          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createSetting(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearSettingDetails());
          dispatch(getAllSetting());
        }
      } else {
        const editPayload = {
          ID: SettingID,

          SettingKey: values?.SettingKey ? values?.SettingKey : "",
          SettingType: values?.SettingType ? values?.SettingType : "",
          SettingValue: values?.SettingValue ? values?.SettingValue : "",

          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateSetting(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearSettingDetails());
          dispatch(getAllSetting());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formloading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={SettingDetail}
      key={formKey}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <Typography.h4 className="m-0">
                {SettingID ? "Update Setting" : "Add Setting"}
              </Typography.h4>
              <IconButton
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
                icon={RxCross1}
              />
            </GridLayoutItem>
            <GridLayoutItem>
              <Field
                name="SettingKey"
                label="Setting Key"
                placeholder="Setting Key"
                component={FormTextField}
                astrike={true}
                disabled={SettingID}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem>
              <Field
                name="SettingValue"
                label="Setting Value"
                placeholder="Setting Value"
                component={FormTextField}
                // validator={requiredValidator}
                // astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem>
              <Field
                name="SettingType"
                label="Setting Type"
                placeholder="Setting Type"
                component={FormTextField}
                // validator={requiredValidator}
                // astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                label={"Status"}
                placeholder={"i.e. Active"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                textAlign: "end",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={SettingID ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formloading}
                loading={formloading}
              />

              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 10 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateSetting;
